import { render, staticRenderFns } from "./FaqsInvestors.vue?vue&type=template&id=1336ce52&scoped=true&"
import script from "./FaqsInvestors.vue?vue&type=script&lang=js&"
export * from "./FaqsInvestors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1336ce52",
  null
  
)

export default component.exports